
// export const imageURL = 'http://localhost:5047/uploads/ledgers';
export const imageURL = 'https://girvibackend2.prakash-n-co.in/uploads/ledgers';
// export const imageURL = 'https://shashibackendb.riddhi-infotech.com/uploads/ledgers';

// export const imageURL = 'https://girvibackend.prakash-n-co.in/uploads/ledgers';
// export const imageURL = 'https://girvibackend.riddhi-infotech.com/uploads/ledgers';
// export const imageURL = 'https://sashigirvibackend.riddhi-infotech.com/uploads/ledgers';
